import { IAuthContext } from 'src/state/providers/AuthProvider';
import { IRequestGenerator } from '../CreateCaseRequestFactory';
import { ICreateCaseRequest } from 'src/state/slice/models/CaseLifecycleTypes';
import { DocumentDetails } from 'src/state/slice/models/CommonTypes';
import { DDMAttributes } from 'src/integration/ddm/providers/DDMAttributesProvider';
import { ReferralInfo } from 'src/state/slice/createCaseSlice';

export class AnonymousUserCreateCaseRequestImpl implements IRequestGenerator {
  private userContext: IAuthContext;
  private payload: any;
  private additionalData: { [key: string]: string };
  private attachments: DocumentDetails[];
  private ddmAttributes: DDMAttributes;

  constructor(
    userContext: IAuthContext,
    payload: any,
    additionalData: { [key: string]: string },
    attachments: DocumentDetails[],
    ddmAttributes: DDMAttributes,
  ) {
    this.userContext = userContext;
    this.payload = payload;
    this.additionalData = additionalData;
    this.attachments = attachments;
    this.ddmAttributes = ddmAttributes;
  }

  generateCreateCaseRequest(): ICreateCaseRequest {
    const referralInformation: ReferralInfo = {
      fullName: 'anonymous',
      email: 'anonymous@amazon.com',
      country: 'NA',
    };

    const updatedPayload = {
      ...this.payload,
      referralInformation: {
        ...referralInformation, //referral
      },
    };
    return {
      userId: 'anonymous',
      accountId: this.userContext.preferredAccountId,
      clientId: this.userContext.clientId,
      ddmSchemaId: this.ddmAttributes.ddmSchemaId!,
      ddmSchemaVersion: this.ddmAttributes.ddmSchemaVersion!,
      caseTitle: this.payload.caseTitle,
      data: JSON.stringify(updatedPayload),
      documentList: this.attachments,
      caseLocale: this.additionalData.caseLocale,
    };
  }
}
